import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOrderStatus from "./chargeOrderStatus";
import ChargeSearchResponse from "./chargeSearchResponse";
import PaymentType from "./paymentType";
import SourceType from "./sourceType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class ChargeOrderSearchResponse {
  id!: string;

  @observable
  orderIdent!: number;

  @observable
  status!: ChargeOrderStatus;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  sourceType!: SourceType;

  @observable
  amount!: number;

  @observable
  paymentType?: PaymentType;

  @observable
  chargesCount!: number;

  @observable
  @Type(() => ChargeSearchResponse)
  charge?: ChargeSearchResponse;
}

export default class ChargeOrderSearch extends ChargeOrderSearchResponse {
  @computed
  get isMultiOrder(): boolean {
    return this.chargesCount > 1;
  }

  @computed
  get searchId() {
    if (this.charge) {
      return `${this.id}-${this.charge.id}`;
    } else {
      return this.id;
    }
  }
}
